<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6" :offset="0">
        <div
          style="border: 1px solid #c5d0e2; border-radius: 2px; padding: 16px"
        >
          <div style="display: flex; align-items: center; font-size: 12px">
            <div style="color: #0f1a3a; font-weight: bold">
              {{ $t("videom.history_video_list") }}(<span
                style="color: rgb(255, 140, 0)"
                >{{ $t("videom.dbclick_play") }}</span
              >)
            </div>
          </div>
          <div
            style="
              height: calc(100vh - 250px);
              overflow-y: auto;
              margin-top: 8px;
            "
          >
            <el-table
              v-loading="loading"
              size="mini"
              :data="tableData"
              border
              @row-dblclick="handleDbClick"
              highlight-current-row
              style="width: 100%"
              :row-style="tableRowStyle"
            >
              <el-table-column
                type="index"
                width="45"
                :label="$t('public.index')"
                align="center"
              >
              </el-table-column>

              <el-table-column
                prop="Channel"
                align="center"
                :label="$t('videom.channel')"
                width="65"
              >
              </el-table-column>
              <el-table-column
                prop="BeginTime"
                align="center"
                :label="$t('time.startTimeHolder')"
                width="85"
              >
                <template slot-scope="scope">
                  {{ formatTime(scope.row.BeginTime) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="EndTime"
                align="center"
                :label="$t('time.endTimeHolder')"
                width="85"
              >
                <template slot-scope="scope">
                  {{ formatTime(scope.row.EndTime) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="VehicleName"
                align="center"
                :label="$t('vehicle.carNo')"
              >
              </el-table-column>
              <el-table-column
                prop="VehicleNo"
                align="center"
                width="95"
                :label="$t('vehicle.DeviceNo')"
              >
              </el-table-column>
            </el-table>

            <kl-pagination
              v-if="false"
              :total="total"
              layout="prev,pager,next"
              @current-change="pageChange"
              :current-page.sync="form.PageNo"
            >
            </kl-pagination>
          </div>
        </div>
      </el-col>
      <el-col :span="18" :offset="0">
        <div style="border: 1px solid #c5d0e2; border-radius: 2px">
          <div
            style="
              font-size: 12px;
              font-weight: bold;
              margin: 16px;
              color: #0f1a3a;
            "
          >
            <div v-if="current.mobile != ''">
              {{ $t("videom.videoplay") }}：{{
                QueryVehicleInfo.vehicleName
              }}_{{ $t("videom.channel") }}{{ current.channel }}（{{
                formatTime(current.BeginTime)
              }}～{{ formatTime(current.EndTime) }}）

              <div v-if="false"  style="float: right; display: flex; align-items: center;">
                <span style="margin-right: 8px; font-size: 12px;">{{ $t('videom.playbackSpeed') }}:</span>
                <el-select v-model="playbackSpeed" size="mini" style="width: 80px; margin-right: 16px;" @change="handleSpeedChange">
                  <el-option :label="'1x'" :value="1"></el-option>
                  <el-option :label="'2x'" :value="2"></el-option>
                  <el-option :label="'4x'" :value="3"></el-option>
                  <el-option :label="'8x'" :value="4"></el-option>
                  <el-option :label="'16x'" :value="5"></el-option>
                </el-select>
               
              </div>
            </div>
            <div v-else>&nbsp;</div>
          </div>
          <div>
            <div style="width: 100%; background: #222222; height: 100%">
              <div style="width: 100%; height: calc(100vh - 250px)">
                <KLVideo
                  :showToolBar="false"
                  ref="klvideo"
                  playMode="history"
                />
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import KLVideo from "@/components/KLVideo/index";
export default {
  components: { KLVideo },
  props: {
    QueryVehicleInfo: {
      type: Object,
      default: {
        vehicleName: "",
        mobile: "",
        beginTime: "",
        endTime: "",
      },
    },
  },
  data() {
    return {
      loading: false,
      total: 0,
      tableData: [
        // {
        //     VehicleName: "sdfas",
        //     VehicleNo: "0021",
        //     Channel: 1,
        //     BeginTime:"240522144302",
        //     EndTime: "240522144302",
        //     FileName:
        //     "s",
        //     FileOffSet: 10,
        //   },{
        //     VehicleName: "sdfas1",
        //     VehicleNo: "00211",
        //     Channel: 2,
        //     BeginTime:"240522144302",
        //     EndTime: "240522144302",
        //     FileName:
        //     "s",
        //     FileOffSet: 10,
        //   }
        ],
      form: {
        AreaName: "",
        PageNo: 1,
        PageSize: 10,
      },
      current: {
        mobile: "",
        channel: 0,
        sessionid: 0,
        url: "",
        BeginTime: "",
        EndTime: "",
      }, //当前播放
      playbackSpeed: 1,
    };
  },
  beforeDestroy() {
    this.stopPlay();//
    this.socketClient.DetachEvent(
      "VehicleVedioResourceList",
      this.socketClient.eventType.onQueryResourceListAck
    );
  },
  created() {
    this.socketClient.AttachEvent(
      "VehicleVedioResourceList",
      this.socketClient.eventType.onQueryResourceListAck,
      this.QueryResourceListAck
    );
  },
  methods: {
    stopPlay() {
      //停止当前历史视频播放
      if (this.current.mobile && this.current.channel) {
        //通知设备停止历史回放
        this.socketClient.socket.RemoteVideoReplayControl(
          this.current.mobile,
          this.current.channel,
          2,
          0,
          "0000-00-00 00:00:00"
        );
        //停止本地播放器，释放播放窗口
        this.$refs.klvideo.CloseVideoBySimNum(this.current.mobile);
      }
    },
    handleSpeedChange(val) {
      if (this.current.mobile && this.current.channel) {
        this.$refs.klvideo.SetHistoryPlaybackRate(this.QueryVehicleInfo.mobile, this.current.channel, val);
      }
    },
    tableRowStyle() {
      return { cursor: "pointer" };
    },
    formatTime(time) {
      //240522144302
      // console.log(time)
      if (time) {
        //  this.moment 20130208T080910
        var t = "20" + time.substr(0, 6) + "T" + time.substr(6);
        var day = this.moment(t);
        return day.format("YYYY-MM-DD HH:mm:ss");``
      }
      return time;
    },

    handleDbClick(row) {
      //双击进行视频播放
      console.log(row);
      if (
        row.Channel == this.current.channel &&
        row.VehicleNo == this.current.mobile &&
        row.BeginTime == this.current.BeginTime &&
        row.EndTime == this.current.EndTime
      ) {
        return;
      }
      //停止之前的播放，释放播放窗口
      if (this.current.mobile && this.current.channel) {
        this.stopPlay();
      }
      this.startPlay(row);
    },
    startPlay(row) {
      console.log("startPlay");
      this.playbackSpeed=1;
      this.current.mobile =this.QueryVehicleInfo.mobile;
      this.current.channel = row.Channel;
      this.current.BeginTime = row.BeginTime;
      this.current.EndTime = row.EndTime;
      this.$refs.klvideo.StartHistoryVideo(
        this.QueryVehicleInfo.mobile,
        row.Channel,
        this.QueryVehicleInfo.vehicleName,
        row.BeginTime,
        row.EndTime
      );
    },

    QueryResourceListAck(v_params) {
      console.log(v_params);
      this.loading = false;
      var resultMsg = "";
      var szResult = v_params.result;
      switch (szResult) {
        case 0:
          resultMsg = "";
          break;
        case 1:
          resultMsg = this.$t("public.Fail");
          break;
        case 2:
          resultMsg = this.$t("deviceresponse.msgError");
          break;
        case 3:
          resultMsg = this.$t("deviceresponse.noSupport");
          break;
        case 0x80:
          resultMsg = this.$t("deviceresponse.offLine");
          break;
        case 0x81:
          resultMsg = this.$t("deviceresponse.noAnswer");
          break;
      }

      if (resultMsg != "") {
        //提示错误
        this.$message({
          message: resultMsg,
          type: "error",
        });
        return;
      }
      this.tableData = [];
      var v_aParam = v_params.param; //通道号：开始时间：结束时间：报警标志：音视频资源类型：码流类型：存储器类型：文件大小：
      console.log(v_aParam);
      if (v_aParam && v_aParam.length > 0) {
        for (var i = 0; i < v_aParam.length; i += 8) {
          this.tableData.push({
            VehicleName: this.QueryVehicleInfo.vehicleName,
            VehicleNo: this.QueryVehicleInfo.mobile,
            Channel: v_aParam[i + 0],
            BeginTime: v_aParam[i + 1],
            EndTime: v_aParam[i + 2],
            FileName:
              v_aParam[i + 4] == 1
                ? this.$t("videom.audio")
                : this.$t("videom.video"),
            FileOffSet: v_aParam[i + 7],
          });
        }
        console.log(this.tableData);
        this.total = this.tableData.length;
      } else {
        this.$message({
          message: this.$t("videom.norecord"),
          type: "warning",
        });
      }
    },
    queryVedioHistory() {
      // this.$refs.klvideo.StartHistoryVideo(
      //   "004011000368",
      //   1,
      //  "asdf",
      //  "250329091105",
      //  "250329091141",
      // );
      // return;

      //参数，下发指令
      var mobile = this.QueryVehicleInfo.mobile;
      var channel =parseInt( this.QueryVehicleInfo.channel);
      var beginTime = this.QueryVehicleInfo.beginTime;
      var endTime = this.QueryVehicleInfo.endTime;
      var alarmFlag = 0;
      var resourceType = 0;
      var codedType = 2;
      var memoryType = 0;
      this.socketClient.socket.QueryResourceListReq(
        mobile,
        channel,
        beginTime,
        endTime,
        alarmFlag,
        resourceType,
        codedType,
        memoryType
      );

      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 10000);
    },
    pageChange(val) {
      this.form.PageNo = val;
      this.getData();
    },
    getData() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }
  },
  mounted() {
 
    //console.log(this.formatTime('240521080222'))
  },
};
</script>
